import { useNavigate } from "react-router-dom";
import "./styles.css";

export const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="flex py-12 px-[20px] justify-start tablet:justify-center w-full flex-col gap-5 tablet:max-w-[1200px] desktop:mx-auto ">
      <div className="text-caption-1-mb tablet:text-caption-1 text-black">
        채권도시 법률사무소
      </div>
      <div className="text-[#9E9E9E] flex flex-col gap-[6px]">
        <div className="flex flex-col tablet:flex-row gap-[6px] tablet:gap-[24px] items-left tablet:items-center text-left">
          <div className="text-caption-2-mb tablet:text-caption-2">
            대표자 : 조근호, 황인규, 박호동
          </div>
          <div className="footer-separator mobile:hidden tablet:block" />
          <div className="text-caption-2-mb tablet:text-caption-2">
            광고책임변호사 : 박호동
          </div>
          <div className="footer-separator mobile:hidden tablet:block" />
          <div className="text-caption-2-mb tablet:text-caption-2">
            개인정보보호책임자 : CISO 조상민
          </div>
        </div>
        <div className="flex flex-col tablet:flex-row gap-[6px] tablet:gap-[24px] items-left tablet:items-center  text-left">
          <div className="text-caption-2-mb tablet:text-caption-2">
            사업자등록번호 : 679-17-01967
          </div>
          <div className="footer-separator mobile:hidden tablet:block desktop:block" />
          <div className="text-caption-2-mb tablet:text-caption-2">
            통신판매업신고번호 : 제2023-서울강남-06033
          </div>
        </div>
        <div className="flex flex-col tablet:flex-row gap-[6px] tablet:gap-[24px] items-left tablet:items-center  text-left">
          <div className="text-caption-2-mb tablet:text-caption-2">
            서울시 강남구 도곡로218, 4층 (CNCITY tower)
          </div>
          <div className="footer-separator mobile:hidden tablet:block" />
          <div className="text-caption-2-mb tablet:text-caption-2">
            02-583-5993
          </div>
        </div>
        <div className="text-caption-2-mb tablet:text-caption-2">
          이메일 : office.law@creditncity.com
        </div>
        <div className="footer-separator-container">
          <div
            className="text-caption-2-mb tablet:text-caption-2 cursor-pointer"
            onClick={() => {
              navigate("/terms");
            }}
          >
            이용약관
          </div>
          <div className="footer-separator" />
          <div
            className="text-caption-2-mb tablet:text-caption-2 !font-bold underline cursor-pointer"
            onClick={() => navigate("/privacy")}
          >
            개인정보처리방침
          </div>
        </div>
        <div className="text-caption-1-mb desktop:text-caption-1 mt-[10px]">
          Copyright credit city office. All rights reserved.
        </div>
      </div>
      <div className="flex gap-4 mt-3">
        <img
          src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/icons/isms-p.webp"
          alt="isms-p"
          className="w-16"
        />
        <div className="flex flex-col text-caption-2-mb desktop:text-caption-2 text-[#9E9E9E]">
          <span>[인증범위] 채권회수 서비스 운영</span>
          <span>[유효기간] 2026.05.20 ~ 2029.05.19</span>
        </div>
      </div>
    </footer>
  );
};
